<template>
  <div class="top-10-container">
    <div class="top-10-product">
      <vue-element-loading :active="loading"></vue-element-loading>
      <vue-element-loading :active="isLoadingAdd" is-full-screen></vue-element-loading>

      <h2 class="top-10-product-headline">{{ title }}</h2>

      <div class="item_destaque top-10-product-information">
        <a :href="linkProduct" title="" class="hovershine container-item hover-link">
          <figure>
            <img :src="productImage" alt="" @error="imageNotFound" />
          </figure>

          <div class="product-fav-bar">
            <span class="tag-promo" v-if="productHavePromotion">Promoção</span>            
            <div v-on:click="handleFav">
              <!--
              <img
                v-if="isFavorited == false"
                class="heart-icon"
                :src="app + '/public/images/site-representante/FAVNORMAL.png'"
              />

              <img
                v-if="isFavorited == true"
                class="heart-icon"
                :src="app + '/public/images/site-representante/FAVORITADO.png'"
              />
              -->
            </div>
          </div>

          <div class="produto_desc">
            <h2>{{ productName }}</h2>
            <small>Ref: {{ productRef }}</small>
          </div>
        </a>

        <div class="carrinho_prod">
          <div class="price">
            <template v-if="productPrice">
              <template v-if="productHavePromotion">
                <span class="preco_orig"><s>{{ formatReal(productPrice) }}</s></span>
              </template>  

              <div class="preco_desc">
                {{ price }}
                <span class="unit"> a unidade</span>
              </div>
            </template>
          </div>

          <small>Quantidade:</small>

          <div class="input-number">
            <button @click="decrement">-</button>
            <input type="text" name="number" min="0" max="1000" value="0" v-on:change="checkQuantity" v-model="quantity" :readonly="alreadyAadded != -1">
            <button @click="increment">+</button>
          </div>

          <small>Embalagem c/{{ productQuantityPackaging }} unidades cada</small>
          
          <template v-if="isCustomerTypeSale && !productPrice">
            <span class="add-button btn-disabled" content="Produto não consta em sua lista de preço. Verifique o orçamento do produto com o seu representante." v-tippy='{ arrow : true }'>
              CONSULTE SEU REPRESENTANTE    
            </span>
          </template>
          <template v-else-if="blockedStatus !== 'not-blocked'">
            <button v-if="blockedStatus === 'requested-notification'" class="notification-button notification-requested">
              <img
                :src="`${app}/public/images/site-representante/icon-clock.svg`"
              />
              AVISO PROGRAMADO
            </button>
            <button v-else class="notification-button notification-request" @click="requestNotification()">
              <img
                :src="`${app}/public/images/site-representante/icon-mail.svg`"
              />
              AVISE-ME QUANDO CHEGAR
            </button>
          </template>
          <template v-else>
            <a :class="[alreadyAadded == -1 ? '' : 'btn-disabled', 'add-button']" @click="addProduct">
              <img :src="app + '/public/images/site-representante/cart.png'" />
              {{ alreadyAadded == -1 ? 'ADICIONAR' : 'ADICIONADO' }}
            </a>
          </template>
          
        </div>
      </div>
      
      <div class="top-10-see-all-container">
        <div class="top-10-see-all">
          <a :href="allProductsLink">
            Ver Todos os Itens <i class="fas fa-chevron-right"></i>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

import { mapState } from 'vuex'
import formatMixin from '../../../../mixins/formatMixin';

export default {
  mixins: [formatMixin],
  props: [
    "loading",
    "title",
    "productName",
    "productRef",
    "productImage",
    "allProductsLink",
    "productLink",
    "productPrice",
    "productPromotionalPrice",
    "productHavePromotion",
    "productQuantityPackaging",
    "productId",
    "productBlockedStatus",
    "type",    
    "isCustomerTypeSale",
  ],
  data() {
    return {
      app: ROOT_URL,
      isFavorited: false,
      quantity: 0,
      isLoadingAdd: false,
      blockedStatus: this.productBlockedStatus
    };
  },
  computed: {
    ...mapState({
      products: state => state.cart.products
    }),
    linkProduct: function () {
      return `${this.productLink}?type=${this.type}`;
    },    
    alreadyAadded: function() {
      let returnKey = -1;
      const search = this.productId;

      $.each(this.products, function(key, info) {
        if (info.produto_id == search) {
          returnKey = key;
          
          return false; 
        };   
      });

      return returnKey; 
    },
    price: function() {
      return this.productHavePromotion ? this.formatReal(this.productPromotionalPrice) : this.formatReal(this.productPrice);
    }
  },
  methods: {
    addProduct() {
      if (this.alreadyAadded != -1) {
        return;
      } 

      const product = {
        produto_id: this.productId,
        embalagem: this.productQuantityPackaging,
        quantidade: this.quantity
      };

      let vm = this;

      vm.isLoadingAdd = true;

      this.$store.dispatch('cart/addProduct', product).then(result => {
        vm.$toasted.success('Produto adicionado', {
          duration:3000, 
          keepOnHover: true
        });

        vm.isLoadingAdd = false;
      }).catch(error => {
        vm.$toasted.error(error, {
          duration:3000, 
          keepOnHover: true, 
          icon:'exclamation-circle'
        });      
        
        vm.isLoadingAdd = false;
      });
    },
    imageNotFound(event) {
      event.target.src =
        ROOT_URL + "/public/images/not-found/340-292/340-292.jpg";
    },
    handleFav: function (event) {
      event.preventDefault();
      this.isFavorited = !this.isFavorited;
    },
    increment() {
      if (this.alreadyAadded == -1) {
        this.quantity += this.productQuantityPackaging;
      }
    },
    decrement() {
      if(this.alreadyAadded == -1) {
        this.quantity = Math.max(0, this.quantity - this.productQuantityPackaging);
      }
    },
    checkQuantity() {
      if (this.alreadyAadded == -1) {
        this.quantity = parseInt(this.productQuantityPackaging ? Math.ceil(this.quantity / this.productQuantityPackaging) * this.productQuantityPackaging : this.quantity);
      }      
    },
    requestNotification() {
      this.isLoadingAdd = true;

      const data = {
        product_id: this.productId
      }

      this.axios.post(`${API_URL}/produtos-bloqueados/solicitar-notificacao`, data ).then(()=>{
        this.blockedStatus = 'requested-notification';
        this.$fire({
          title: 'Aviso programado com sucesso!',
          text: 'Você receberá um e-mail quando este produto estiver disponível para compra.',
          type: 'success',
          confirmButtonText: 'OK',
          allowOutsideClick: false,
          customClass:   {
            title: 'notification-alert-title',
            confirmButton: 'notification-alert-confirm',
            content: 'notification-alert-text'
          }
        })
      }).catch(()=>{
        this.$toasted.error('Erro ao solicitar aviso de chegada', {
          duration:3000, 
          keepOnHover: true, 
          icon:'exclamation-circle'
        });      
      }).finally(()=>{
        this.isLoadingAdd = false;
      })
    },
  },
  mounted() {
    this.quantity = this.productQuantityPackaging;
  },
};
</script>